<script lang="ts">
  export let id: string | undefined = undefined;
</script>

<h1 {id}>
  <slot />
</h1>
